<template>
  <div class="mt-2 mb-4">
    <div class="mb-3 d-flex align-items-center">
      <div class="mr-4 title">
        {{ $l('group_detail_img_file') || '图片文件' }}
      </div>
      <el-button size="mini" @click="onAdd" v-if="evgPackingSchemeGroupCode">{{
        $l('button_add_img') || '新增图片'
      }}</el-button>
    </div>
    <div>
      <div class="mb-2" v-for="(item, index) in groupDetailList" :key="index">
        <ArtworkItem
          :item.sync="item"
          @save="saveItem"
          @delete="deleteItem"
          :currIndex="index"
          @change="(e) => change(e, index)"
        />
      </div>
      <el-empty
        v-if="!groupDetailList || !groupDetailList.length"
        :description="$l('INDEX.tips_no_data') || '暂无数据！'"
      ></el-empty>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import ArtworkItem from './ArtworkItem.vue'
export default {
  components: { ArtworkItem },
  props: {
    evgPackingSchemeGroupCode: String,
    evgPackingSchemeCode: String,
  },
  mixins: [EditLoading],
  data() {
    return {
      groupDetailList: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api
        .ecomEvgPackingSchemeDescGroupDetailListApi({
          evgPackingSchemeGroupCode: this.evgPackingSchemeGroupCode,
        })
        .then(({ status, body }) => {
          if (status == 200) {
            this.groupDetailList = body.data?.map((t) => ({
              ...t,
              readonly: true,
              isNew: false,
            }))
          }
        })
    },
    onAdd() {
      this.groupDetailList.unshift({
        readonly: false,
        isNew: true,
        imgDesc: '',
        fileName: '',
        fileSize: 0,
        file: null,
        v_fileSize: '',
        displayImageUrl: '',
      })
    },
    async saveItem(item) {
      this.loadingOpen()
      let file = {}
      if (item.file) {
        const { status, body } = await this.$api.SYS_UPLOAD(item.file)
        if (status != 200) {
          this.$message.error(
            this.$l('INDEX.uploader_label_status_error') || '上传失败'
          )
          return
        }
        file = body || {}
      }

      await this.$api
        .ecomEvgPackingSchemeDescGroupDetailSaveApi({
          evgPackingSchemeGroupDetailCode: item.evgPackingSchemeGroupDetailCode,
          evgPackingSchemeGroupCode: this.evgPackingSchemeGroupCode,
          evgPackingSchemeCode: this.evgPackingSchemeCode,
          originImageCode: file.fileId,
          fileUrl: file.displayImageUrl,
          fileName: item.fileName,
          fileSize: item.fileSize,
          imgDesc: item.imgDesc,
        })
        .then(({ status, body }) => {
          if (status != 200) {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败')
            this.loadingClose()
            return
          }
          this.$message.success(this.$l('INDEX.tips_save_ok') || '保存成功')
          this.loadingClose()
          this.$emit('reload')
          this.getData()
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    deleteItem(index) {
      this.loadingOpen()
      const item = this.groupDetailList[index]
      const { evgPackingSchemeGroupDetailCode } = item
      if (!evgPackingSchemeGroupDetailCode) {
        this.$message.success(this.$l('INDEX.tips_delete_ok') || '删除成功')
        this.groupDetailList.splice(index, 1)
        this.loadingClose()
        return
      }
      this.$api
        .ecomEvgPackingSchemeDescGroupDetailDelApi({
          evgPackingSchemeGroupDetailCode: item.evgPackingSchemeGroupDetailCode,
        })
        .then(({ status, body }) => {
          if (status != 200) {
            this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败')
            this.loadingClose()
            return
          }
          this.$message.success(this.$l('INDEX.tips_delete_ok') || '删除成功')
          this.loadingClose()
          this.$emit('reload')
          this.groupDetailList.splice(index, 1)
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    change(e, index) {
      this.groupDetailList[index].readonly = e.readonly
      this.groupDetailList[index].isNew = e.isNew
      this.groupDetailList[index].imgDesc = e.imgDesc
      this.groupDetailList[index].fileName = e.fileName
      this.groupDetailList[index].fileSize = e.fileSize
      this.groupDetailList[index].file = e.file
      this.groupDetailList[index].v_fileSize = e.v_fileSize
      this.groupDetailList[index].displayImageUrl = e.displayImageUrl
    },
  },
}
</script>
<style scoped>
.title {
  font-size: 16px;
  color: #101010;
  font-weight: 600;
}
</style>
